import React, { useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import { useLocation } from 'react-router-dom';

function RoomOverview({ hotelRoom })
{
    const ref = useRef();

    const location = useLocation();

    useLayoutEffect(() =>
    {
        if (ref.current) ref.current.scrollIntoView({ block: 'center' });
    }, [location.pathname]);

    return (
        <section id="overview" className="tw-py-10 lg:tw-py-20 tw-px-4 tw-bg-gray-300">
            <div ref={ref} className="xl:tw-container tw-text-center">
                <Fade bottom>
                    <h2 className="font-arapey tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 leading-12">{hotelRoom.name}</h2>
                </Fade>
                <Fade bottom>
                    <div className="tw-flex tw-flex-wrap tw-mt-12 tw-text-left tw-justify-center">
                        <div className="tw-w-full lg:tw-pl-8  lg:tw-border-gray-500">
                            <p className="tw-text-2xl">{hotelRoom.description}</p>
                        </div>
                    </div>
                </Fade>
            </div>
        </section>
    );
}

RoomOverview.propTypes = {
    hotelRoom: PropTypes.object.isRequired,
};

export default RoomOverview;
